import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["value", "children"];
import { jsxs, jsx } from 'react/jsx-runtime';
import { Checkmark } from '@box/blueprint-web-assets/icons/Fill';
import { Gray100 } from '@box/blueprint-web-assets/tokens/tokens';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';
import { forwardRef, useCallback } from 'react';
import { composeEventHandlers } from '../../utils/composeEventHandlers.js';
import styles from './dropdown-menu.module.js';
/**
 * Based on Radix-UI RadioItem
 * @see https://www.radix-ui.com/docs/primitives/components/dropdown-menu#radioitem
 */

var DropdownMenuRadioSelectItem = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var value = props.value,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var preventDefault = useCallback(function (event) {
    return event.preventDefault();
  }, []);
  return jsxs(DropdownMenuPrimitive.RadioItem, _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    className: clsx(styles.item, styles.radioItem),
    onPointerLeave: composeEventHandlers(props.onPointerLeave, preventDefault),
    onPointerMove: composeEventHandlers(props.onPointerMove, preventDefault),
    value: value,
    children: [jsx(DropdownMenuPrimitive.ItemIndicator, {
      className: styles.checkmark,
      children: jsx(Checkmark, {
        color: Gray100,
        height: "1rem",
        role: "presentation",
        width: "1rem"
      })
    }), jsx("span", {
      className: styles.ellipsis,
      children: children !== null && children !== void 0 ? children : value
    })]
  }));
});
DropdownMenuRadioSelectItem.displayName = 'DropdownMenuRadioSelectItem';
export { DropdownMenuRadioSelectItem };